(function () {
  'use strict';

  var SURFACE = 'homepage';
  var SESSION_KEY = 'lg_click_session';
  var IMPRESSION_THRESHOLD = 0.5;

  function deviceType() {
    return (window.innerWidth < 768) ? 'mobile' : 'desktop';
  }

  function tileLocation(tile) {
    var container = tile && tile.closest && tile.closest('[data-gallery-location]');
    if (container) {
      var loc = container.getAttribute('data-gallery-location');
      if (loc) return loc;
    }
    return SURFACE;
  }

  function safeGtag() {
    if (typeof window.gtag === 'function') return window.gtag;
    // queue via dataLayer if gtag not yet defined but dataLayer exists
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      return function () {
        window.dataLayer.push(arguments);
      };
    }
    return null;
  }

  function toInt(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  function tileParams(tile) {
    return {
      gallery_surface: SURFACE,
      gallery_location: tileLocation(tile),
      image_filename: tile.getAttribute('data-filename') || '',
      image_type: tile.getAttribute('data-image-type') || '',
      gallery_shot_type: tile.getAttribute('data-gallery-shot-type') || '',
      gallery_room_type: tile.getAttribute('data-gallery-room-type') || '',
      gallery_position: toInt(tile.getAttribute('data-gallery-position')),
      image_sku: tile.getAttribute('data-sku') || '',
      product_title: tile.getAttribute('data-product-name') || '',
      gallery_variant: tile.getAttribute('data-gallery-variant') || '',
      gallery_week_code: tile.getAttribute('data-gallery-week-code') || '',
      image_url: tile.getAttribute('data-url') || '',
      performance_tier: tile.getAttribute('data-performance-tier') || '',
      image_score: tile.getAttribute('data-score') || '',
      device_type: deviceType(),
      page_path: window.location.pathname
    };
  }

  function fireEvent(name, params) {
    var gtag = safeGtag();
    if (!gtag) return;
    try { gtag('event', name, params); } catch (e) {}
  }

  // -------- Session click tracking (for ATC attribution) --------
  function readSession() {
    try {
      var raw = window.sessionStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }
  function writeSession(obj) {
    try { window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  function normalizePath(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      return u.pathname;
    } catch (e) {
      return String(url).split('?')[0];
    }
  }

  function recordClick(tile) {
    var params = tileParams(tile);
    fireEvent('gallery_click', params);
    // stash into session for ATC attribution, keyed by product path
    var href = tile.getAttribute('href') || '';
    var productPath = normalizePath(href);
    if (!productPath) return;
    var session = readSession();
    session[productPath] = {
      filename: params.image_filename,
      image_type: params.image_type,
      shot_type: params.gallery_shot_type,
      room_type: params.gallery_room_type,
      position: params.gallery_position,
      sku: params.image_sku,
      product_title: params.product_title,
      variant: params.gallery_variant,
      week_code: params.gallery_week_code,
      url: params.image_url,
      performanceTier: params.performance_tier,
      score: params.image_score,
      gallery_location: params.gallery_location,
      clicked_at: Date.now()
    };
    writeSession(session);

    // Append referral context to tile link for cross-surface attribution
    var refSep = tile.href.indexOf('?') > -1 ? '&' : '?';
    tile.href += refSep + 'img_ref=gallery'
      + '&img_surface=' + encodeURIComponent(params.gallery_location || 'unknown');
  }

  // -------- Impression tracking --------
  var observed = new WeakSet();
  var fired = new WeakSet();
  var io = null;

  function getObserver() {
    if (io || typeof IntersectionObserver === 'undefined') return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.intersectionRatio < IMPRESSION_THRESHOLD) return;
        var tile = entry.target;
        if (fired.has(tile)) return;
        fired.add(tile);
        fireEvent('gallery_impression', tileParams(tile));
        io.unobserve(tile);
      });
    }, { threshold: [IMPRESSION_THRESHOLD] });
    return io;
  }

  function observeTiles(scope) {
    var obs = getObserver();
    var tiles = (scope || document).querySelectorAll('.gallery-tile');
    Array.prototype.forEach.call(tiles, function (tile) {
      if (observed.has(tile)) return;
      observed.add(tile);
      if (obs) obs.observe(tile);
      tile.addEventListener('click', function () { recordClick(tile); });
    });
  }

  // -------- ATC detection on product page --------
  function isProductPage() {
    return /^\/products\//.test(window.location.pathname);
  }

  function matchSession() {
    var session = readSession();
    var path = window.location.pathname;
    if (session[path]) return session[path];
    // also try referrer path (if navigated away and came back)
    var refPath = normalizePath(document.referrer);
    if (refPath && session[refPath]) return session[refPath];
    return null;
  }

  function atcParamsFromEntry(entry) {
    return {
      gallery_surface: SURFACE,
      gallery_location: entry.gallery_location || SURFACE,
      image_filename: entry.filename || '',
      image_type: entry.image_type || '',
      gallery_shot_type: entry.shot_type || '',
      gallery_room_type: entry.room_type || '',
      gallery_position: toInt(entry.position),
      image_sku: entry.sku || '',
      product_title: entry.product_title || '',
      gallery_variant: entry.variant || '',
      gallery_week_code: entry.week_code || '',
      image_url: entry.url || '',
      performance_tier: entry.performanceTier || '',
      image_score: entry.score || '',
      device_type: deviceType(),
      page_path: window.location.pathname
    };
  }

  function attachAtcListeners() {
    if (!isProductPage()) return;
    var entry = matchSession();
    if (!entry) return;

    var atcFired = false;
    function fireAtc() {
      if (atcFired) return;
      atcFired = true;
      fireEvent('gallery_atc', atcParamsFromEntry(entry));
    }

    // Listen for classic form submit
    var forms = document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (f) {
      f.addEventListener('submit', fireAtc, true);
    });
    // Listen for click on common ATC buttons as a fallback
    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest && e.target.closest('[name="add"], button[type="submit"][name="add"], .product-form__submit, [data-add-to-cart]');
      if (target) fireAtc();
    }, true);

    // Intercept fetch to Shopify's /cart/add.js (AJAX ATC)
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (url && /\/cart\/add(\.js)?/.test(url)) {
            return origFetch.apply(this, arguments).then(function (res) {
              if (res && res.ok) fireAtc();
              return res;
            });
          }
        } catch (e) {}
        return origFetch.apply(this, arguments);
      };
    }
  }

  // -------- Init --------
  function init() {
    observeTiles(document);
    attachAtcListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan after gallery renders (async algorithm completion) or editor reloads
  document.addEventListener('lifestyle-gallery:ready', function (e) {
    var scope = (e.detail && e.detail.section) || document;
    observeTiles(scope);
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) observeTiles(e.target);
  });

  // Expose for debugging
  window.__galleryTracking = {
    fireEvent: fireEvent,
    tileParams: tileParams,
    readSession: readSession
  };
})();
